export const getDeepCopyOfObject = <O extends Array<unknown> | object>(obj: O): O =>
  structuredClone(obj) as O
